import ChevronIcon from "../img/chevronIcon"

const StatusView = () => {
    return (
        <main>
            <h2 className="text-center mt-4 text-lg">Fluxo para pedidos com entrega pelos <strong>CORREIOS</strong></h2>
            <CorreiosStatusFlow />
            <h2 className="text-center mt-10 text-lg">Fluxo para pedidos com entrega <strong>PRESENCIAL</strong></h2>
            <PresencialStatusFlow />
            <h2 className="text-center mt-10 text-lg">Fluxo para pedidos com entrega <strong>PARCEIROS</strong></h2>
            <HubStatusFlow />
        </main>
    )
}

export const CorreiosStatusFlow = () => {
    return (
        <div className="flex gap-4 flex-wrap items-center px-10 py-4">
            <StatusTablet label="CARRINHO" name="CART" description="Cliente adiciona pedido no carrinho" bgColor="#F9C0A0" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="PAGAMENTO PROCESSADO" name="PROCESSED" description="Pagamento é processado" bgColor="#F9C0A0" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="PAGAMENTO AUTORIZADO" name="APPROVED" description="Pagamento é autorizado" bgColor="#F9C0A0" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="ENVIADO PARA MANAFIX" name="SENT" description="Cliente envia o pedido" bgColor="#F9C0A0" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="RECEBIDO" name="QUEUE" description="Manafix recebe o pedido" bgColor="#F9C0A0" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="AVALIANDO" name="GRADING" description="Manafix começa a avaliação" bgColor="#F9C0A0" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="EM PROCESSO DE LACRE" name="GRADED" description="Manafix termina a avaliação" bgColor="#F9C0A0" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="ENVIADO PARA CLIENTE" name="RETURNED" description="Manafix envia o pedido" bgColor="#F9C0A0" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="FINALIZADO" name="DONE" description="Manafix finaliza o processo" bgColor="#F9C0A0" />
        </div>
    )
}

export const PresencialStatusFlow = () => {
    return (
        <div className="flex gap-4 flex-wrap items-center px-10 py-4">
            <StatusTablet label="CARRINHO" name="CART" description="Cliente adiciona pedido no carrinho" bgColor="#F18992" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="PAGAMENTO PROCESSADO" name="PROCESSED" description="Pagamento é processado" bgColor="#F18992" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="PAGAMENTO AUTORIZADO" name="APPROVED" description="Pagamento é autorizado" bgColor="#F18992" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="RECEBIDO" name="QUEUE" description="Manafix recebe o pedido" bgColor="#F18992" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="AVALIANDO" name="GRADING" description="Manafix começa a avaliação" bgColor="#F18992" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="EM PROCESSO DE LACRE" name="GRADED" description="Manafix termina a avaliação" bgColor="#F18992" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="AGUARDANDO RETIRADA" name="AWAITING" description="Aguardando cliente retirar o pedido" bgColor="#F18992" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="FINALIZADO" name="DONE" description="Manafix finaliza o processo" bgColor="#F18992" />
        </div>
    )
}

export const HubStatusFlow = () => {
    return (
        <div className="flex gap-4 flex-wrap items-center px-10 py-4">
            <StatusTablet label="CARRINHO" name="CART" description="Cliente adiciona pedido no carrinho" bgColor="#EA99C7" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="PAGAMENTO PROCESSADO" name="PROCESSED" description="Pagamento é processado" bgColor="#EA99C7" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="PAGAMENTO AUTORIZADO" name="APPROVED" description="Pagamento é autorizado" bgColor="#EA99C7" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="AGUARDANDO MANAFIX" name="HOLD" description="Parceiro recebe o pedido" bgColor="#EA99C7" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="RECEBIDO" name="QUEUE" description="Manafix busca o pedido" bgColor="#EA99C7" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="AVALIANDO" name="GRADING" description="Manafix começa a avaliação" bgColor="#EA99C7" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="EM PROCESSO DE LACRE" name="GRADED" description="Manafix termina a avaliação" bgColor="#EA99C7" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="AGUARDANDO RETIRADA" name="AWAITING" description="Aguardando cliente retirar o pedido" bgColor="#EA99C7" />
            <div className="transform -rotate-90 h-fit w-fit m-0">
                <ChevronIcon width="30px" />
            </div>
            <StatusTablet label="FINALIZADO" name="DONE" description="Manafix finaliza o processo" bgColor="#EA99C7" />
        </div>
    )
}


export const StatusTablet = ({ label, name, description, bgColor = "#fff" }) => {
    return (
        <div className="text-center text-md w-fit max-w-[200px] text-black">
            <div className="border border-black h-20 flex items-center justify-center px-2" style={{ backgroundColor: bgColor }}>
                {description}
            </div>
            <div className="bg-green-300 h-12 flex items-center justify-center">
                {label}
            </div>
            <div className="text-white">
                {name}
            </div>
        </div>
    )
}

export default StatusView;
